<template>
  <div class="d-flex flex-column flex-grow-1">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="products"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :sort="sort"
    ></filtered-data>

    <div class="container-fluid d-flex align-items-center">
      <h2 class="page-heading mr-auto">Продукты</h2>
      <router-link
        v-if="$root.checkPermission('web_recipes_edit')"
        class="btn btn-primary mr-2"
        :to="`/settings/recipes/products/create`"
      >
        Добавить продукт
      </router-link>
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        :hasMore="hasMore"
        :loading="loading"

        @sort-change="sortChange"
        @load-more="$refs.data.loadMore"
      >
        <el-table-column sortable="keyword" label="Наименование" prop="name"/>
        <el-table-column align="center" width="220">
          <template slot-scope="{row, $index}">
            <btn-action
              class="btn btn-sm btn-outline-light mr-2"
              @click="() => remove(row, $index)"
            >
              Удалить
            </btn-action>
            <router-link
              class="btn btn-sm btn-outline-light"
              :to="`/settings/recipes/products/${row.id}`"
            >
              Редактировать
            </router-link>
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import api from '@/api'

  export default {
    metaInfo: {title: 'Продукты'},
    data () {
      return {
        filtersValue: {},
        data: {},
        loading: false,
        hasMore: true,
        sort: null,
      }
    },
    methods: {
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          this.sort = `${sort.prop}:${order}`
        } else {
          this.sort = null
        }
      },
      remove (product, index) {
        if (window.confirm('Удалить продукт?')) {
          return api.delete('products/' + product.id).then((data) => {
            this.data.data.splice(index, 1)
          })
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/settings/recipes/products/index.vue